import { useState } from "react";
import { Outlet } from "react-router-dom";
import { CrmScrollContainerContext } from "./CrmScrollContext";
import { useAuth } from "../../hooks/useAuth";
import { DashboardLayout } from "../dashboard/components/DashboardLayout";
import { DashboardNav } from "../dashboard/components/DashboardNav";
import { DashboardHeader } from "../dashboard/components/DashboardHeader";
import { ConfirmModal } from "../../components/ConfirmModal";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { LogoutIcon } from "../../assets/LogoutIcon";

export const CrmLayout = () => {
  const { user, logout } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  // The scrolling element for every CRM page — list pages restore their place against
  // it. Held as state so pages mounting alongside the layout re-render once it exists.
  // HTMLElement, not HTMLDivElement: the scroll container is the <main> landmark.
  const [scrollContainer, setScrollContainer] = useState<HTMLElement | null>(null);

  const handleLogoutConfirm = async () => {
    try {
      await logout();
      setShowLogoutModal(false);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNav onLogout={() => setShowLogoutModal(true)} />
      <div className="dashboard-content">
        <DashboardHeader
          title="Communication"
          userEmail={user?.email || "Unknown"}
        />
        <main
          className="dashboard-section-container"
          id="main-content"
          tabIndex={-1}
          ref={setScrollContainer}
        >
          <ErrorBoundary
            fallbackTitle="CRM Error"
            fallbackMessage="This section encountered an error. Try refreshing the page."
          >
            <CrmScrollContainerContext.Provider value={scrollContainer}>
              <Outlet />
            </CrmScrollContainerContext.Provider>
          </ErrorBoundary>
        </main>
      </div>

      <ConfirmModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogoutConfirm}
        title="Logout"
        message="Are you sure you want to logout?"
        confirmText="Yes, Logout"
        cancelText="Cancel"
        icon={<LogoutIcon />}
      />
    </DashboardLayout>
  );
};
